// extracted by mini-css-extract-plugin
export default {"pre":"Output_pre__y12g0","box":"Output_box__szrJl","code":"Output_code__dajfV"};